import { render, staticRenderFns } from "./add_order.vue?vue&type=template&id=399d5cc2&scoped=true"
import script from "./add_order.vue?vue&type=script&lang=js"
export * from "./add_order.vue?vue&type=script&lang=js"
import style0 from "./add_order.vue?vue&type=style&index=0&id=399d5cc2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399d5cc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('399d5cc2')) {
      api.createRecord('399d5cc2', component.options)
    } else {
      api.reload('399d5cc2', component.options)
    }
    module.hot.accept("./add_order.vue?vue&type=template&id=399d5cc2&scoped=true", function () {
      api.rerender('399d5cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/add_order.vue"
export default component.exports